export const setDateFormat = (day, hour) => {
    const date = new Date();
    date.setDate(date.getDate() - day);
    if (hour <= 0) {
        date.setHours(0, 0, 0, 0);
    } else {
        date.setHours(23, 59, 59, 59);
    }
    return date;
};
export const geTdayToPassSunday = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysToSunday = dayOfWeek === 0 ? 7 : dayOfWeek;
    const sundayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - daysToSunday);
    return sundayDate;
};

export const getSundayWeekAgo = () => {
    const today = new Date();
    const daysToSunday = today.getDay() + 7;
    const sundayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - daysToSunday);
    return sundayDate;
};
export const getSaturdayWeekAgo = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const daysToSaturday = dayOfWeek === 6 ? 7 : dayOfWeek + 1;
    const saturdayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - daysToSaturday);
    return saturdayDate;
};
export const getTodayFilter = (isPrev = false) => {
    const date = new Date();
    const offSet = isPrev ? 1 : 0;
    date.setDate(date.getDate() - offSet);

    const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();
    date.setDate(date.getDate() - 1);
    const start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).getTime();

    return { start, end };
}



export const getWeekFilter = (isPrev = false) => {

    const date = new Date();
    const offSet = isPrev ? 7 : 0;
    date.setDate(date.getDate() - offSet);
    const end = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay(), 0, 0, 0, 0).getTime();
    const start = new Date(date.getFullYear(), date.getMonth(), date.getDate() - date.getDay() - 7, 0, 0, 0, 0).getTime();

    return { start, end }
}

export const getMonthFilter = (isPrev = false) => {
    const today = new Date();
    const offSet = isPrev ? 2 : 1;

    const date = new Date(today.getFullYear(), today.getMonth() - offSet, 1);;


    const start = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0).getTime();
    const end = new Date(date.getFullYear(), date.getMonth() + offSet, 0, 0, 0, 0, 0).getTime();

    return { start, end }
}
export const getYearFilter = (isPrev = false) => {
    const today = new Date();
    const offSet = isPrev ? 2 : 1;

    const date = new Date(today.getFullYear() - offSet, 0, 1);
    console.log(date)


    const start = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0).getTime();
    const end = new Date(date.getFullYear() + offSet, date.getMonth(), 1, 0, 0, 0, 0).getTime();

    return { start, end }
}
